import RenderCategoryItemSelectors from './RenderCategoryItemSelectors';
import RenderCategoryItemAdvice from './RenderCategoryItemAdvice';

function RenderCategoryItems({ categoryDataItems, forPDF = false }) {
  return (
    Object.values(categoryDataItems).map((item) => {
      const hasSelectors = Array.isArray(item.new_selectors) && item.new_selectors.length > 0;

      return (
        <>
          {!forPDF ? (
            <div key={item.id} className="accordion accordion-flush">
              <div className="accordion-item rounded-4">
                <button
                  className="accordion-button collapsed border-top rounded-bottom-4"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#panelsStayOpen-${item.id}`}
                  aria-expanded="false"
                  aria-controls={`panelsStayOpen-${item.id}`}
                >
                  {item.description}
                </button>
                <div
                  id={`panelsStayOpen-${item.id}`}
                  className="accordion-collapse collapse"
                >
                  <div className="accordion-body">
                    <div className="row">
                      {hasSelectors && (
                        <div className="col-xl-8">
                          <RenderCategoryItemSelectors categoryDataItemSelectors={item.new_selectors} />
                        </div>
                      )}
                      <div className={hasSelectors ? "col-xl-4" : "col"}>
                        <RenderCategoryItemAdvice itemId={item.id} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div key={item.id} className="mb-3 pdf-avoid-break">
              <div className="py-3 bg-white border-bottom fw-semibold">
                {item.description}
              </div>

              <div className="">
                <div className="mb-3">
                  <RenderCategoryItemAdvice itemId={item.id} />
                </div>

                {hasSelectors && (
                  <div>
                    <RenderCategoryItemSelectors categoryDataItemSelectors={item.new_selectors} />
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      );
    })
  );
}


export default RenderCategoryItems;
